import React from 'react';
import { Button } from 'antd-v5';
import './styles.css';

const ProductDetailsModalFooter = props => {
  const { buttonLabel, onSave, onClose, loading, disabled } = props;

  return (
    <div className="flex-row-center m-top-30 maw-600" style={{ gap: '12px' }}>
      <Button size="large" onClick={onClose}>
        Cancel
      </Button>
      <Button type="primary" size="large" onClick={onSave} disabled={disabled}>
        {buttonLabel || 'Save'}
      </Button>
    </div>
  );
};

export default ProductDetailsModalFooter;
